import { withStyles } from '@mui/styles';
import { Button, ButtonProps } from '@mui/material/';

const CustomButton = withStyles({
  root: {
    display: 'flex',
    width: '400px',
    padding: '12px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    height: '48px',
    lineHeight: 1.5,
    '&:hover': {
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
    },
  },
})(Button);

interface IProps extends ButtonProps {
  label: string;
  onClick: () => void;
  dataTestId?: string;
}

export const SessionOutlineButton = ({ label, onClick, dataTestId }: IProps) => {
  return (
    <CustomButton
      variant='contained'
      onClick={onClick}
      style={{
        fontWeight: 600,
        backgroundColor: '#ffffff',
        color: '#202223',
        border: '1px solid #D1D6DB',
      }}
      {...(dataTestId && { 'data-testid': dataTestId })}
    >
      {label}
    </CustomButton>
  );
};
